module.exports = __webpack_public_path__ + "img/logo.196b6066.svg";